import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import { HandleReactComponentRendering } from '@ClientBase/React/RenderReactComponents'
import { declareClientPackage, RuntimeDetails } from '@ClientBase/IClientPackage'
import { JobFiltersEventHandler } from '@ClientBase/Generic/JobFiltersEventHandler'
import { PostFiltersEventHandler } from '@ClientBase/Generic/PostFiltersEventHandler'
import { BurgerMenuEventHandler } from '@ClientBase/Generic/BurgerMenuEventHandler'
import * as Carousels from './Carousels'
import * as VideoSnippet from './VideoSnippet'
import * as DomMainipulations from './DomMainipulations'
import * as Navigation from './Navigation'
import * as SearchOverlay from './SearchOverlay'
import * as Filters from './Filters'
import * as StickyApply from './StickyApply'
import * as JobTile from './JobTile'
import * as Modal from './Modal'
import * as PostTile from './PostTile'
import * as ListWidget from './ListWidget'
import * as SocialProfile from './SocialProfileWidget'
import * as Footer from './Footer'
import * as HomeHeroBanner from './HomeHeroBanner'
import SnippetSpacer from './Spacer/Spacer'
import SnippetHeading from './Heading/Heading'
import SnippetContent from './Content/Content'
import SnippetImageContent from './ImageContent/ImageContent'
import SnippetContentColumn from './ContentColumn/ContentColumn'
import SnippetLinkBox from './LinkBox/LinkBox'
import SnippetTabSwitcher from './TabSwitcher/TabSwitcher'
import SnippetIconsText from './IconsText/IconsText'
import SnippetAccordionReact from './Accordion/Accordion'
import SnippetVideo from './Video/Video'
import HeroLinks from "./HeroLinks/HeroLinks";
import SnippetLogos from "./Logos/Logos";
import ImageContentAlternative from "./ImageContentAlternative/ImageContentAlternative";
import SnippetLinkCard from "./LinkCard/LinkCard";
import ApplicationProcess from "./ApplicationProcess/ApplicationProcess";
import Timeline from './Timeline/Timeline';
import SnippetStats from './Stats/Stats';
import SnippetImageContentFullWidth from "./ImageContentFullWidth/ImageContentFullWidth";
import Testimonials from "./Testimonials/Testimonials";
import StatsAlternative from "./StatsAlternative/StatsAlt";
import ImageGallery from "./ImageGallery/ImageGallery";
import JobDetailsVideo from "./JobDetailsVideo/JobDetailsVideo";
import SnippetParagraph from "./Paragraph/Paragraph";
import SnippetImage from "./Image/Image";
import * as JobDetails from "./JobDetails";
/**
 * Extend the ClientBase class so you can benefit from any event hooks that Attrax offers,
 * and so that Attrax knows you have defined specific methods
 */

const _Components = {
    'SnippetSpacer': SnippetSpacer,
    'SnippetHeading': SnippetHeading,
    'SnippetContent' : SnippetContent,
    'SnippetImageContent': SnippetImageContent,
    'SnippetContentColumn': SnippetContentColumn,
    'SnippetLinkBox': SnippetLinkBox,
    'SnippetTabSwitcher': SnippetTabSwitcher,
    'SnippetIconsText' : SnippetIconsText,
    'SnippetAccordion' : SnippetAccordionReact,
    'SnippetVideo' : SnippetVideo,
    'HeroLinks': HeroLinks,
    'SnippetLogos': SnippetLogos,
    'ImageContentAlternative': ImageContentAlternative,
    'SnippetLinkCard': SnippetLinkCard,
    'ApplicationProcess': ApplicationProcess,
    'Timeline': Timeline,
    'SnippetStats': SnippetStats,
    'SnippetImageContentFullWidth': SnippetImageContentFullWidth,
    'Testimonials': Testimonials,
    'StatsAlternative': StatsAlternative,
    'ImageGallery': ImageGallery,
    'JobDetailsVideo': JobDetailsVideo,
    'SnippetParagraph': SnippetParagraph,
    'SnippetImage': SnippetImage,
}


declareClientPackage({
    onCmsSnippetPreview() {
        HandleReactComponentRendering(React, ReactDOM, _Components)
    },
    onDocumentReady(details: RuntimeDetails) {
        HandleReactComponentRendering(React, ReactDOM, _Components)
        Navigation.navigationFunctions()
        DomMainipulations.removeSocialWidgetIfEmpty()
        JobFiltersEventHandler.useAttraxTsHandlers($)
        PostFiltersEventHandler.useAttraxTShandler($)
        BurgerMenuEventHandler.handleClickEvents($)
        VideoSnippet.VideoClickHandler()
        DomMainipulations.moveLinkedInButton($)
        DomMainipulations.moveFilterButton($)
        DomMainipulations.repositionBioModal($)
        DomMainipulations.shortlistRedirect($)
        DomMainipulations.showValidationIfTrue($)
        DomMainipulations.createStickyApplyHeading($)
        DomMainipulations.moveKeyword()
        DomMainipulations.moveSendCvModal($)
        DomMainipulations.removeFooterAutocomplete($)
        DomMainipulations.showExpiredVacancyBanner($)
        DomMainipulations.removeNonBreakingSpaceFromJobDetails()
        DomMainipulations.addFilterTextHeadingJobResults()
        DomMainipulations.showAuthorDetailsIfAuthor()
        DomMainipulations.addSearchButtonToHeroSearchWidget()
        DomMainipulations.openApplyFormInNewTab()
        Carousels.initialise()
        Filters.scrollHandler($)
        Filters.jobFiltersLocationClickHandler();
        Filters.postFiltersBtnClickHandler();
        Filters.postFiltersAccessibility();
        Filters.jobFiltersSearchFilterAccessibility();
        HomeHeroBanner.FadeEffect();
        StickyApply.showStickyApply()
        JobTile.addLogo()
        JobTile.logoReplacer()
        JobTile.brandClassAssignment()
        JobTile.setActive()
        JobTile.wrapJobTitleInH3()
        Modal.closeModalOnBgClick()
        PostTile.makePostTileClickable()
        ListWidget.checkIfJobTilesHaveProfile()
        ListWidget.cloneHeading()
        ListWidget.makePaginationAccessible()
        SocialProfile.displayRecruiterIfAvailable()
        Footer.FooterHandlers()
        SearchOverlay.initialise()
        JobDetails.jobDetails()
        $(document).on('job-filter-initialized', function () {
            (window as any).jobFilterNoReloadController.enableDefaultFilterCounts()
        })
    }
})
